import { useRouter } from 'expo-router';
import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import Logo from '../../assets/images/logo.svg';
import { REDESIGN_COLORS } from '../../styles/colors';
import HeaderCTA from './HeaderCTA';
import HeaderCountdownChip from './HeaderCountdownChip';
import { useResponsive } from '../../hooks/useResponsive';

const ScreenHeader = ({ title, subtitle, hideLogo = false }) => {
  const { isMobile } = useResponsive();
  const router = useRouter();
  // On desktop, DesktopHeader owns the HeaderCTA. ScreenHeader is used as an in-page
  // title block on desktop (see /cars), so rendering HeaderCTA here would duplicate.
  // Pages that already render DesktopHeader can pass hideLogo to drop the
  // duplicate centre-column logo.
  return (
    <View>
      {!hideLogo && (
        <View style={styles.logoRow}>
          <Pressable
            onPress={() => router.push('/home')}
            accessibilityRole="link"
            accessibilityLabel="Go to home"
          >
            <Logo width={100} height={21} />
          </Pressable>
          {isMobile && (
            <View style={styles.rightGroup}>
              <HeaderCountdownChip />
              <HeaderCTA />
            </View>
          )}
        </View>
      )}
      {title ? (
        <View style={styles.titleSection}>
          <Text style={styles.title}>{title}</Text>
          {subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  logoRow: {
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  rightGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  titleSection: {
    paddingHorizontal: 16,
    marginTop: 16,
    gap: 4,
    marginBottom: 16,
  },
  title: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 24,
    color: REDESIGN_COLORS.textPrimary,
  },
  subtitle: {
    fontFamily: 'Satoshi-Regular',
    fontSize: 12,
    color: REDESIGN_COLORS.textSecondary,
  },
});

export default ScreenHeader;
